/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable max-len */
var english_months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var french_months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
var englishLanguageSelected = 'English';
export function parseDateToLanguage(monthNumber, language) {
    if (language === englishLanguageSelected) {
        return english_months[monthNumber];
    }
    return french_months[monthNumber];
}
export function getLinkTextFromDate(lastUpdateDate, languageSelected) {
    if (lastUpdateDate) {
        var officialDate = new Date(lastUpdateDate.toString());
        var monthNumber = officialDate.getMonth();
        var parsedMonth = parseDateToLanguage(monthNumber, languageSelected);
        var parsedDate = "".concat(parsedMonth, " ").concat(officialDate.getDate(), ", ").concat(officialDate.getFullYear());
        return "Last Updated: ".concat(parsedDate);
    }
    return 'Not Started';
}
//# sourceMappingURL=Utils.js.map